<script setup lang="ts">
import type { ElementalTypeEnum } from '~~/src/types/elemental'
import MenuItem from '@/components/FloatMenu/FloatMenuOption/indev.vue'
import { useRemoveSaveElemental } from '~~/src/composables/mutations/elemetal/useRemoveSaveElemental'
import { useRemoveSaveElementalInAList } from '~~/src/composables/mutations/elemetal/useRemoveSaveElementalInAList'

const props = defineProps<Props>()

defineOptions({
  name: 'RemoveSaveElementalItem',
})

interface Props {
  id?: string
  elementalType: ElementalTypeEnum
  listId?: string | number
  listType?: ElementalTypeEnum
}

const isAllList = computed(() => isNaN(Number(props.listId)))
const { mutate, isPending } = useRemoveSaveElemental()
const { mutate: mutateInAList, isPending: isPendingInAList } = useRemoveSaveElementalInAList()

const handlerChange = async () => {
  if (!props.id)
    return

  if (!isAllList.value && props.listId) {
    mutateInAList({
      id: props.id,
      elementalType: props.elementalType,
      listId: props.listId,
    })
    return
  }
  mutate({
    id: props.id,
    elementalType: props.elementalType,
    listId: props.listId,
    listType: props.listType,
  })
}
</script>

<template>
  <MenuItem :disabled="isPending || isPendingInAList" @select="handlerChange">
    <template #icon>
      <div i-material-symbols:bookmark-outline w-3 h-3 />
    </template>
    {{ !isAllList ? 'Remove from List' : ' Unsave' }}
  </MenuItem>
</template>
